import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { myrtleBeachConfig } from "./data";

export default function MyrtleBeachPage() {
  return <CityPageTemplate config={myrtleBeachConfig} />;
}